module.exports = __webpack_public_path__ + "static/media/Elf4.9eb33372.png";